import React from 'react';
import { keyframes } from '@emotion/react';
import { Box, Flex } from '@chakra-ui/react';
import Media from '@components/atoms/Media';
import HeaderFont from '@components/atoms/HeaderFont';

const marqueeAnimation = keyframes`
  from {
    transform: translate3d(0%, 0, 0);
  }

  to {
    transform: translate3d(-50%, 0, 0);
  }
`;

const TickerTape = ({
  tickerTapeItems = [],
  itemWrapperProps = {},
  itemProps = {},
  speed = `200s`,
  ...props
}) => {
  return (
    <Box {...props}>
      <Box width="100%" overflow="hidden">
        <Flex
          width="max-content"
          position="relative"
          sx={{ animation: `${marqueeAnimation} ${speed} linear infinite` }}>
          {tickerTapeItems.map((item, i) => (
            <Box
              key={`tickerTapeItems${i + 1}`}
              animation-play-state="running"
              {...itemWrapperProps}>
              {typeof item === `string` ? (
                <HeaderFont {...itemProps}>{item}</HeaderFont>
              ) : (
                <Media
                  width="auto"
                  height="10px"
                  objectFit="cover"
                  display="inline-flex"
                  media={item.images}
                  {...itemProps}
                />
              )}
            </Box>
          ))}
        </Flex>
      </Box>
    </Box>
  );
};

export default TickerTape;
